import { SmartComponentPropertyDetails } from "../smart-components/smart-component-property-details";
import { IComponentLoader } from "../../interfaces/IComponentLoader";
import { ComponentAdapterParent } from "./component-adapter-parent";
import { SkillNameList } from "../../enum/enumSkillNameList";
import { AddressDetails } from "../smart-components/smart-component-property";

/**
 * This class handle properties of contact
 */
export class ComponentAdaperContact
  extends ComponentAdapterParent
  implements IComponentLoader {
  private _contactCommand: AddressDetails = null;
  private _contactState: AddressDetails = null;

  /**
   * Get the contact command address
   */
  get ContactCommand(): AddressDetails {
    return this._contactCommand;
  }

  /**
   * Get the contact state address
   */
  get ContactState(): AddressDetails {
    return this._contactState;
  }

  constructor() {
    super();
  }

  public fillProperty(
    listSmartComponentSkills: Array<SmartComponentPropertyDetails>
  ): void {
    this._name =
      listSmartComponentSkills.find(
        (titleSkill) => titleSkill.titleSkill === SkillNameList.CONTACT_NAME
      )?.value || "";
    this._description =
      listSmartComponentSkills.find(
        (titleSkill) =>
          titleSkill.titleSkill === SkillNameList.CONTACT_DESCRIPTION
      )?.value || "";

    this._contactCommand =
      listSmartComponentSkills.find(
        (titleSkill) => titleSkill.titleSkill === SkillNameList.CONTACT_COMMAND
      )?.address || null;
    this._contactState =
      listSmartComponentSkills.find(
        (titleSkill) => titleSkill.titleSkill === SkillNameList.CONTACT_STATE
      )?.address || null;

    this.fillMissingProperty();
    this.fillAddressState();
  }

  public fillMissingProperty(): void { }

  public fillAddressState(): void {
    if (this._contactState !== null) {
      this._listSubscribeAddress.push(this._contactState);
    }
  }
}
